import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const phoneNumberValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const phone = control.value?.trim();
  if (!phone) return { required: true };
  const phoneRegex = /^\+?\d+$/;
  return phoneRegex.test(phone) ? null : { invalidPhoneNumber: true };
};
